// src/composables/useDialog.ts
import { computed } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import {
  XmlConversionBadInputError,
  DepositSubmissionError,
  DepositSubmissionAuthenticationError,
  XmlConversionNetworkError,
  XmlConversionError,
  DepositSubmissionNetworkError
} from "@content-registration/errors";
import ErrorDialogBase from '@/components/dialogs/error/ErrorDialogBase.vue';
import ErrorDialogXmlConversionBadDataError from '@/components/dialogs/error/ErrorDialogXmlConversionBadDataError.vue';
import ErrorDialogXmlConversionError from '@/components/dialogs/error/ErrorDialogXmlConversionError.vue';
import ErrorDialogDepositSubmissionError from '@/components/dialogs/error/ErrorDialogDepositSubmissionError.vue';
import ErrorDialogDepositSubmissionAuthenticationError from '@/components/dialogs/error/ErrorDialogDepositSubmissionAuthenticationError.vue';
import ErrorDialogXmlConversionNetworkError from '@/components/dialogs/error/ErrorDialogXmlConversionNetworkError.vue';
import ErrorDialogDepositSubmissionNetworkError from '@/components/dialogs/error/ErrorDialogDepositSubmissionNetworkError.vue';

export const useDialog = () => {
  const dialogStore = useDialogStore();

  const dialog = computed(() => dialogStore.dialog);

  const dismissDialog = () => {
    dialogStore.dismissDialog();
  };

  const executeCallback = () => {
    dialogStore.executeCallback();
  };

  const getDialogComponent = (error: Error) => {
    if (error instanceof XmlConversionBadInputError){
      return ErrorDialogXmlConversionBadDataError;
    }
    if (error instanceof XmlConversionError) {
      return ErrorDialogXmlConversionError;
    }
    if (error instanceof XmlConversionNetworkError) {
      return ErrorDialogXmlConversionNetworkError;
    }
    if (error instanceof DepositSubmissionNetworkError) {
      return ErrorDialogDepositSubmissionNetworkError;
    }
    if (error instanceof DepositSubmissionError) {
      return ErrorDialogDepositSubmissionError
    }
    if (error instanceof DepositSubmissionAuthenticationError){
      return ErrorDialogDepositSubmissionAuthenticationError
    }
    return ErrorDialogBase;
  };

  const getDialogTitle = (error: Error) => {
    return 'Error';
  };

  return {
    dialogStore,
    dialog,
    dismissDialog,
    executeCallback,
    getDialogComponent,
    getDialogTitle,
  };
};
